import { Button, Box } from "@mui/material";
import { useState } from "react";
import { useMutation } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";
import CustomModal from "../../global/custom-modal";
import LoadingSpinner from "../../global/loading-spinner";

const ChangeFactorStatus = ({ factorID }) => {
  const [action, setAction] = useState("check-finished-trace");
  const [actionChange, setActionChange] = useState("change-factor-status");
  const [openModal, setOpenModal] = useState(false);

  const { data, mutate, isLoading } = useMutation(({ action, factor_id }) =>
    AxiosT.post(`/out-warehouse-with-factor/${factorID}`, {
      action,
      factor_id,
    })
  );

  const handleModal = () => {
    setOpenModal(true);
    mutate({
      action: action,
      factor_id: factorID,
    });
  };
  const factor_statuses = data?.data.result.factor_statuses;

  const mutate2 = useMutation(
    ({ action, factor_id, status_id }) =>
      AxiosT.post(`/out-warehouse-with-factor/${factorID}`, {
        action,
        factor_id,
        status_id,
      }),
    {
      onSuccess: (data) => {
        setOpenModal(false);
      },
    }
  );

  const handleChange = (fs_id) => {
    console.log(fs_id);
    mutate({
      action: actionChange,
      factor_id: factorID,
      status_id: fs_id,
    });
  };

  return (
    <>
      <Button
        variant="contained"
        style={{ border: "1px solid #fff" }}
        onClick={handleModal}
      >
        تغییر وضعیت
      </Button>
      <CustomModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        titleModal="تغییر وضعیت فاکتور"
      >
        {isLoading && <LoadingSpinner />}
        {factor_statuses?.map((row) => (
          <Box key={row.fs_id} mb={1}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => handleChange(row.fs_id)}
            >
              {row.fs_name}
            </Button>
          </Box>
        ))}
      </CustomModal>
    </>
  );
};
export default ChangeFactorStatus;
